import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated } from '@/api/auth'
import LoginView from '@/views/LoginView.vue'
import GenericMapView from '@/views/GenericMapView.vue'

const routes = [
    {
        path: '/',
        redirect: '/map',
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginView
    },
    {
        path: '/map',
        name: 'Map',
        component: GenericMapView,
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});

router.beforeEach((to) => {
    if (to.meta.requiresAuth && !isAuthenticated()) {
        return { name: 'Login' }
    }
})

export default router